import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';

export interface IGridAction {
    text: string;
    callback: () => void;
    inverted: boolean;
}

@Component({
    selector: 'lib-grid-actions',
    templateUrl: './grid-actions.component.html',
    styleUrls: ['./grid-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class GridActionsComponent {
    @Input()
    actions: IGridAction[] = [];

    @Input()
    gridActionsId?: string;

    buttonClicked(action: IGridAction) {
        action.callback();
    }
}
